import { useCallback } from 'react';

import { FileReceiver } from '~hooks/useComposerAttachments/useComposerAttachments';

export default function useAttachmentPaste(receiver: FileReceiver) {
  return useCallback(
    (event: React.ClipboardEvent) => {
      const pastedFiles = Array.from(event.clipboardData.files);
      const pastedText = event.clipboardData.getData('text/plain');

      // Spreadsheet and document copies carry a picture of the selection beside its text.
      if (pastedFiles.length === 0 || pastedText.length > 0) return;

      event.preventDefault();
      receiver(pastedFiles);
    },
    [receiver],
  );
}
